var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { generateReducer, } from "../generators/generator.reducer";
import { createDocumentPackageStart, createDocumentPackageSucceeded, createDocumentPackageFailed, revokeDocumentPackageStart, revokeDocumentPackageSucceeded, revokeDocumentPackageFailed, remindDocumentPackageSignerStart, remindDocumentPackageSignerSucceeded, remindDocumentPackageSignerFailed, } from "./documentPackage.actions";
import { GENERATOR_PARAMS } from "./documentPackage.constants";
var getExtraDefaultState = function () { return ({
    revoke: {},
    remind: {},
    create: {},
}); };
var _reducer = generateReducer(GENERATOR_PARAMS, getExtraDefaultState);
var reducer = _reducer;
reducer.on(createDocumentPackageStart.type, function (state, payload) {
    return __assign(__assign({}, state), { create: __assign(__assign({}, state.create), { isCreating: true, createError: undefined }) });
});
reducer.on(createDocumentPackageSucceeded.type, function (state, payload) {
    return __assign(__assign({}, state), { create: __assign(__assign({}, state.create), { item: payload.data, isCreating: false, createError: undefined }) });
});
reducer.on(createDocumentPackageFailed.type, function (state, payload) {
    return __assign(__assign({}, state), { create: __assign(__assign({}, state.create), { isCreating: false, createError: payload.error }) });
});
reducer.on(revokeDocumentPackageStart.type, function (state, payload) {
    var _a;
    var _b;
    return __assign(__assign({}, state), { revoke: __assign(__assign({}, state.revoke), (_a = {}, _a[payload.documentPackageId] = __assign(__assign({}, (_b = state === null || state === void 0 ? void 0 : state.revoke) === null || _b === void 0 ? void 0 : _b[payload.documentPackageId]), { isRevoking: true, revokeError: undefined }), _a)) });
});
reducer.on(revokeDocumentPackageSucceeded.type, function (state, payload) {
    var _a;
    var _b;
    return __assign(__assign({}, state), { revoke: (_a = {},
            _a[payload.documentPackageId] = __assign(__assign({}, (_b = state === null || state === void 0 ? void 0 : state.revoke) === null || _b === void 0 ? void 0 : _b[payload.documentPackageId]), { isRevoking: false, revokeError: undefined }),
            _a) });
});
reducer.on(revokeDocumentPackageFailed.type, function (state, payload) {
    var _a;
    var _b;
    return __assign(__assign({}, state), { revoke: (_a = {},
            _a[payload.documentPackageId] = __assign(__assign({}, (_b = state === null || state === void 0 ? void 0 : state.revoke) === null || _b === void 0 ? void 0 : _b[payload.documentPackageId]), { isRevoking: false, revokeError: payload.error }),
            _a) });
});
reducer.on(remindDocumentPackageSignerStart.type, function (state, payload) {
    var _a;
    var _b;
    return __assign(__assign({}, state), { remind: (_a = {},
            _a[payload.documentPackageId] = __assign(__assign({}, (_b = state === null || state === void 0 ? void 0 : state.remind) === null || _b === void 0 ? void 0 : _b[payload.documentPackageId]), { isReminding: true, remindError: undefined }),
            _a) });
});
reducer.on(remindDocumentPackageSignerSucceeded.type, function (state, payload) {
    var _a;
    var _b;
    return __assign(__assign({}, state), { remind: (_a = {},
            _a[payload.documentPackageId] = __assign(__assign({}, (_b = state === null || state === void 0 ? void 0 : state.remind) === null || _b === void 0 ? void 0 : _b[payload.documentPackageId]), { isReminding: false, remindError: undefined }),
            _a) });
});
reducer.on(remindDocumentPackageSignerFailed.type, function (state, payload) {
    var _a;
    var _b;
    return __assign(__assign({}, state), { remind: (_a = {},
            _a[payload.documentPackageId] = __assign(__assign({}, (_b = state === null || state === void 0 ? void 0 : state.remind) === null || _b === void 0 ? void 0 : _b[payload.documentPackageId]), { isReminding: false, remindError: payload.error }),
            _a) });
});
// eslint-disable-next-line import/no-default-export
export default reducer;
